import React, { useState, useRef } from "react";
import { toast } from "react-toastify";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";

// import JS files
import { useUserData } from "../../../../context/UserDataContext";
import useFetch from "../../../../context/useFetch";
import MuiButton from "../../../shares/MuiButton";
import { fixNumbers } from "../../../../utils";

const AdminPrintReportBangleOnprogressCustomer = () => {
  const navigate = useNavigate();

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
  });

  const [requestList, setRequestList] = useState([]);
  const [bangleDetail, setbangleDetail] = useState({});
  const { userData } = useUserData();
  const { bangle } = useParams();
  const getBangleDetail = useFetch({
    method: "post",
    url: `Bangle_Service/get_bangle_using_code`,
    data: {
      code: bangle,
    },
    trigger: bangle !== "0" ? true : false,
    setter: setbangleDetail,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const getRequestListApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/admin_get_report_bangle_onprogress_customer`,
    trigger: true,
    params:
      bangle !== "0"
        ? {
            code: fixNumbers(bangle),
          }
        : {},
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const componentRef = useRef();

  return (
    <>
      <div className="my-4">
        <div className="flex justify-between items-center mx-8">
          <span className="text-sm">برای دانلود فایل PDF کلیک کنید.</span>
          <div className="flex">
            <ReactToPrint
              trigger={() => {
                return (
                  <MuiButton
                    variant="contained"
                    color="primary"
                    text="دانلود فایل PDF"
                    size="small"
                    //    icon={<ModeEditIcon />}
                  />
                );
              }}
              content={() => componentRef.current}
            />
            <div className="mr-4">
              <MuiButton
                onClick={() => navigate(-1)}
                variant="outlined"
                color="secondary"
                text="بازگشت"
                size="small"
                icon={<ArrowBackIcon />}
              />
            </div>
          </div>
        </div>
        <div
          className="printTable mx-8"
          ref={componentRef}
          style={{ direction: "rtl" }}
        >
          <div className="text-center mt-8">
            <span className="font-bold">درخواست مشتریان</span>
          </div>
          <div className="border rounded-md mt-4 overflow-hidden">
            <div className="flex justify-between">
              <div className="basis-1/2  text-center py-1 ">
                <span className="text-sm text-myblue-100">ردیف</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">النگو</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">رنگ</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">نوع</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">نام</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">نام خانوادگی</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">نام فروشگاه</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> ت.یک</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> ت.دو</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> ت.سه</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> ت.چهار</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> ت.پنج</span>
              </div>
              <div className=" basis-1/2 text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> ت.شش</span>
              </div>
            </div>

            {requestList.map((item, index) => {
              return [
                <>
                  <div className="printTableTr flex justify-between">
                    <div className="basis-1/2 border-t  text-center py-1">
                      <span className="text-sm text-myblue-100">
                        {index + 1}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.bangle.code}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.color == "yellow" ? "زرد" : "سفید"}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.gender == "woman" ? "زنانه" : "بچه گانه"}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.first_name}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.last_name}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.store_name}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.admin_own_accept_size_one_num}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.admin_own_accept_size_two_num}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.admin_own_accept_size_three_num}
                      </span>
                    </div>
                    <div className=" basis-1/2 border-t text-center py-1 border-r">
                      <span className="text-sm text-myblue-100">
                        {item.admin_own_accept_size_four_num}
                      </span>
                    </div>
                    <div className=" basis-1/2 border-t text-center py-1 border-r">
                      <span className="text-sm text-myblue-100">
                        {item.admin_own_accept_size_five_num}
                      </span>
                    </div>
                    <div className=" basis-1/2 border-t text-center py-1 border-r">
                      <span className="text-sm text-myblue-100">
                        {item.admin_own_accept_size_six_num}
                      </span>
                    </div>
                  </div>
                  {index == 21 ? <div className="break"></div> : undefined}
                </>,
              ];
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminPrintReportBangleOnprogressCustomer;
